const customersNamespace = '/customers';

const customerListViewRelative = '/';
const customerListViewRoute = `${customersNamespace}${customerListViewRelative}`;


export const customersNamespaces = {
    customersNamespace,
};

export const customersRelativeRoutes = {
    customerListViewRelative,
};

export const customersAbsoluteRoutes = {
    customerListViewRoute,
};
